/* ============================================================
   SUTRACRAFT — HEADER
   Sticky compression, mega-menu, search overlay, mobile panel.
   ============================================================ */
(function () {
  'use strict';

  // --- Elements -----------------------------------------------------------
  const header        = document.getElementById('siteHeader');
  if (!header) return;

  const backdrop      = document.getElementById('backdrop');
  const searchOverlay = document.getElementById('searchOverlay');
  const searchInput   = document.getElementById('searchInput');
  const searchClose   = document.getElementById('searchCloseBtn');
  const mobilePanel   = document.getElementById('mobilePanel');
  const hamburgerBtn  = document.getElementById('hamburgerBtn');
  const mobileClose   = document.getElementById('mobileCloseBtn');

  const megaTriggers  = header.querySelectorAll('[data-mega]');
  const megas         = header.querySelectorAll('.mega-menu');

  // --- Sticky compression -------------------------------------------------
  function onScroll() {
    if (window.scrollY > 80) header.classList.add('is-scrolled');
    else                     header.classList.remove('is-scrolled');
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // --- Mega-menu ----------------------------------------------------------
  let openTimer  = null;
  let closeTimer = null;
  let activeMega = null;

  function closeAllMegas() {
    megas.forEach(m => m.classList.remove('is-open'));
    megaTriggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
    activeMega = null;
  }

  function openMega(name) {
    clearTimeout(closeTimer);
    if (activeMega === name) return;
    closeAllMegas();
    const panel   = header.querySelector('.mega-menu[data-menu-target="' + name + '"]');
    const trigger = header.querySelector('[data-mega="' + name + '"]');
    if (!panel) return;
    panel.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    backdrop && backdrop.classList.add('is-active');
    activeMega = name;
  }

  function closeMega() {
    closeTimer = setTimeout(() => {
      closeAllMegas();
      if (!isSearchOpen()) backdrop && backdrop.classList.remove('is-active');
    }, 150);
  }

  megaTriggers.forEach(trigger => {
    const name = trigger.dataset.mega;
    trigger.addEventListener('mouseenter', () => {
      clearTimeout(closeTimer);
      openTimer = setTimeout(() => openMega(name), 80);
    });
    trigger.addEventListener('mouseleave', () => {
      clearTimeout(openTimer);
      closeMega();
    });
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (activeMega === name) {
        closeAllMegas();
        if (!isSearchOpen()) backdrop && backdrop.classList.remove('is-active');
      } else {
        openMega(name);
      }
    });
  });

  megas.forEach(panel => {
    panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    panel.addEventListener('mouseleave', closeMega);
  });

  // --- Search overlay -----------------------------------------------------
  function isSearchOpen() {
    return searchOverlay && searchOverlay.classList.contains('is-open');
  }
  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('is-open');
    backdrop && backdrop.classList.add('is-active');
    setTimeout(() => searchInput && searchInput.focus(), 200);
  }
  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('is-open');
    if (!activeMega) backdrop && backdrop.classList.remove('is-active');
  }

  document.querySelectorAll('[data-search-open]').forEach(btn => {
    btn.addEventListener('click', (e) => { e.preventDefault(); openSearch(); });
  });
  searchClose && searchClose.addEventListener('click', closeSearch);

  // --- Backdrop & Esc -----------------------------------------------------
  backdrop && backdrop.addEventListener('click', () => {
    closeAllMegas();
    closeSearch();
    backdrop.classList.remove('is-active');
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllMegas();
      closeSearch();
      backdrop && backdrop.classList.remove('is-active');
      closeMobilePanel();
    }
  });

  // --- Mobile panel -------------------------------------------------------
  function openMobilePanel() {
    if (!mobilePanel) return;
    mobilePanel.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMobilePanel() {
    if (!mobilePanel) return;
    mobilePanel.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  hamburgerBtn && hamburgerBtn.addEventListener('click', openMobilePanel);
  mobileClose  && mobileClose.addEventListener('click', closeMobilePanel);

  // --- Top-level accordion (mobile) ----------------------------------------
  // Each [data-accordion] button toggles its sibling .accordion-content.
  // Opening one does NOT close others — lets users compare sections easily.
  // First sub-section inside is auto-opened on first expand.
  document.querySelectorAll('[data-accordion]').forEach(btn => {
    btn.addEventListener('click', () => {
      const wasExpanded = btn.getAttribute('aria-expanded') === 'true';
      const body = btn.nextElementSibling;
      if (!body || !body.classList.contains('accordion-content')) return;

      const nowExpanded = !wasExpanded;
      btn.setAttribute('aria-expanded', nowExpanded);
      body.classList.toggle('is-open', nowExpanded);

      // On first open: expand the first sub-section automatically
      // so the panel doesn't feel empty.
      if (nowExpanded) {
        const firstSub = body.querySelector('[data-sub]');
        if (firstSub && firstSub.getAttribute('aria-expanded') !== 'true') {
          openSubSection(firstSub);
        }
      }
    });
  });

  // --- Sub-section accordion (mobile) --------------------------------------
  // Independent of the top-level: tapping a sub-header opens/closes just
  // that sub-section. No accordion exclusivity — users can leave multiple
  // sub-sections open at once (useful when scanning / comparing).
  function openSubSection(btn) {
    const subBody = btn.nextElementSibling;
    if (!subBody || !subBody.classList.contains('sub-body')) return;
    btn.setAttribute('aria-expanded', 'true');
    subBody.classList.add('is-open');
  }

  function closeSubSection(btn) {
    const subBody = btn.nextElementSibling;
    if (!subBody || !subBody.classList.contains('sub-body')) return;
    btn.setAttribute('aria-expanded', 'false');
    subBody.classList.remove('is-open');
  }

  document.querySelectorAll('[data-sub]').forEach(btn => {
    btn.addEventListener('click', () => {
      if (btn.getAttribute('aria-expanded') === 'true') {
        closeSubSection(btn);
      } else {
        openSubSection(btn);
      }
    });
  });

  // --- Cart count public API ----------------------------------------------
  // Call window.SutracraftHeader.updateCartCount(n) from your cart drawer
  // logic after add/remove operations. Keeps every badge in sync.
  function updateCartCount(count) {
    const n = parseInt(count, 10) || 0;
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      el.textContent = n;
      if (n > 0) el.removeAttribute('hidden');
      else       el.setAttribute('hidden', '');
    });
  }

  window.SutracraftHeader = { updateCartCount: updateCartCount };

  // Auto-sync once on Section Rendering API load (Shopify customizer)
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('#siteHeader')) onScroll();
  });

})();
// /* ============================================================
//    SUTRACRAFT — HEADER
//    Sticky compression, mega-menu, search overlay, mobile panel.
//    ============================================================ */
// (function () {
//   'use strict';

//   // --- Elements -----------------------------------------------------------
//   const header        = document.getElementById('siteHeader');
//   if (!header) return;

//   const backdrop      = document.getElementById('backdrop');
//   const searchOverlay = document.getElementById('searchOverlay');
//   const searchInput   = document.getElementById('searchInput');
//   const searchClose   = document.getElementById('searchCloseBtn');
//   const mobilePanel   = document.getElementById('mobilePanel');
//   const hamburgerBtn  = document.getElementById('hamburgerBtn');
//   const mobileClose   = document.getElementById('mobileCloseBtn');

//   const megaTriggers  = header.querySelectorAll('[data-mega]');
//   const megas         = header.querySelectorAll('.mega-menu');

//   // --- Sticky compression -------------------------------------------------
//   function onScroll() {
//     if (window.scrollY > 80) header.classList.add('is-scrolled');
//     else                     header.classList.remove('is-scrolled');
//   }
//   window.addEventListener('scroll', onScroll, { passive: true });
//   onScroll();

//   // --- Mega-menu ----------------------------------------------------------
//   let openTimer = null;
//   let closeTimer = null;
//   let activeMega = null;

//   function closeAllMegas() {
//     megas.forEach(m => m.classList.remove('is-open'));
//     megaTriggers.forEach(t => t.setAttribute('aria-expanded', 'false'));
//     activeMega = null;
//   }

//   function openMega(name) {
//     clearTimeout(closeTimer);
//     if (activeMega === name) return;

//     closeAllMegas();

//     const panel   = header.querySelector('.mega-menu[data-menu-target="' + name + '"]');
//     const trigger = header.querySelector('[data-mega="' + name + '"]');
//     if (!panel) return;

//     panel.classList.add('is-open');
//     trigger.setAttribute('aria-expanded', 'true');
//     backdrop && backdrop.classList.add('is-active');
//     activeMega = name;
//   }

//   function closeMega() {
//     closeTimer = setTimeout(() => {
//       closeAllMegas();
//       if (!isSearchOpen()) backdrop && backdrop.classList.remove('is-active');
//     }, 150);
//   }

//   megaTriggers.forEach(trigger => {
//     const name = trigger.dataset.mega;

//     trigger.addEventListener('mouseenter', () => {
//       clearTimeout(closeTimer);
//       openTimer = setTimeout(() => openMega(name), 80);
//     });
//     trigger.addEventListener('mouseleave', () => {
//       clearTimeout(openTimer);
//       closeMega();
//     });
//     trigger.addEventListener('click', (e) => {
//       e.preventDefault();
//       if (activeMega === name) {
//         closeAllMegas();
//         if (!isSearchOpen()) backdrop && backdrop.classList.remove('is-active');
//       } else {
//         openMega(name);
//       }
//     });
//   });

//   megas.forEach(panel => {
//     panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
//     panel.addEventListener('mouseleave', closeMega);
//   });

//   // --- Search overlay -----------------------------------------------------
//   function isSearchOpen() {
//     return searchOverlay && searchOverlay.classList.contains('is-open');
//   }
//   function openSearch() {
//     if (!searchOverlay) return;
//     searchOverlay.classList.add('is-open');
//     backdrop && backdrop.classList.add('is-active');
//     setTimeout(() => searchInput && searchInput.focus(), 200);
//   }
//   function closeSearch() {
//     if (!searchOverlay) return;
//     searchOverlay.classList.remove('is-open');
//     if (!activeMega) backdrop && backdrop.classList.remove('is-active');
//   }

//   // Multiple search triggers (tier 2, compact-state, mobile bottom nav)
//   document.querySelectorAll('[data-search-open]').forEach(btn => {
//     btn.addEventListener('click', (e) => { e.preventDefault(); openSearch(); });
//   });
//   searchClose && searchClose.addEventListener('click', closeSearch);

//   // --- Backdrop & Esc -----------------------------------------------------
//   backdrop && backdrop.addEventListener('click', () => {
//     closeAllMegas();
//     closeSearch();
//     backdrop.classList.remove('is-active');
//   });

//   document.addEventListener('keydown', (e) => {
//     if (e.key === 'Escape') {
//       closeAllMegas();
//       closeSearch();
//       backdrop && backdrop.classList.remove('is-active');
//       mobilePanel && mobilePanel.classList.remove('is-open');
//       document.body.style.overflow = '';
//     }
//   });

//   // --- Mobile panel -------------------------------------------------------
//   hamburgerBtn && hamburgerBtn.addEventListener('click', () => {
//     mobilePanel.classList.add('is-open');
//     document.body.style.overflow = 'hidden';
//   });
//   mobileClose && mobileClose.addEventListener('click', () => {
//     mobilePanel.classList.remove('is-open');
//     document.body.style.overflow = '';
//   });

//   // Mobile accordions
//   document.querySelectorAll('[data-accordion]').forEach(btn => {
//     btn.addEventListener('click', () => {
//       const expanded = btn.getAttribute('aria-expanded') === 'true';
//       btn.setAttribute('aria-expanded', !expanded);
//       const content = btn.nextElementSibling;
//       if (content && content.classList.contains('accordion-content')) {
//         content.classList.toggle('is-open', !expanded);
//       }
//     });
//   });

//   // --- Cart count public API ---------------------------------------------
//   // Call window.SutracraftHeader.updateCartCount(n) from your cart drawer
//   // logic after add/remove operations. Keeps every badge in sync.
//   function updateCartCount(count) {
//     const n = parseInt(count, 10) || 0;
//     document.querySelectorAll('[data-cart-count]').forEach(el => {
//       el.textContent = n;
//       if (n > 0) el.removeAttribute('hidden');
//       else       el.setAttribute('hidden', '');
//     });
//   }

//   window.SutracraftHeader = { updateCartCount: updateCartCount };

//   // Auto-sync once on Section Rendering API load (Shopify customizer)
//   document.addEventListener('shopify:section:load', (e) => {
//     if (e.target.querySelector('#siteHeader')) onScroll();
//   });
// })();
